import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row justify-content-center"
};
const _hoisted_2 = {
    class: "col-xs-12 col-md-8 mt-5",
    id: "block_error"
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h2", null, "Opps! Keine Berechtigung...", -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", null, " Für diese Funktion haben Sie keine Berechtigung. ", -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createTextVNode(" Für weitere Fragen wenden Sie sich bitte an Ihren Helpdesk. "),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode("Vielen Dank. ... ;) ")
], -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_8 = { class: "text-warning" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("td", { style: { "padding-right": "50px" } }, "Zeitstempel:", -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("td", null, "Fehler:", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.statusCode === 403)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, [
                    _hoisted_3,
                    _hoisted_4,
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7,
                    _createElementVNode("table", _hoisted_8, [
                        _createElementVNode("tr", null, [
                            _hoisted_9,
                            _createElementVNode("td", null, _toDisplayString(_ctx.$utils.formatDate(Date.now(), 'date-time')), 1)
                        ]),
                        _createElementVNode("tr", null, [
                            _hoisted_10,
                            _createElementVNode("td", null, _toDisplayString(_ctx.$utils.createId()), 1)
                        ])
                    ])
                ])
            ])
        ]))
        : (_ctx.statusCode === 0 || _ctx.statusCode === 200)
            ? _renderSlot(_ctx.$slots, "default", { key: 1 })
            : _createCommentVNode("", true);
}
